export const TOTALS_ROW_ID = '__totals__';
